<template>
  <div :class="className" :style="{height:height,width:width}" />
</template>

<script>
import * as echarts from "echarts"
// require('echarts/theme/macarons') // echarts theme
import resize from './mixins/resize'

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '350px'
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    chartData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      chart: null
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val)
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el)
      this.setOptions(this.chartData)
    },
    setOptions({ timeList, activeList,stopList,totalCardList,delCardList } = {}) {
      this.chart.setOption({
        title: {
          text: '月激活停机销卡',
          subtext: '每月激活和停机次数统计分析'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        toolbox: {
          feature: {
            dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ['line', 'bar'] },
            restore: { show: true },
            saveAsImage: { show: false }
          }
        },
        color: ['#34bfa3','#f4516c', '#36a3f7'],
        legend: {
          data: ['激活数', '停机数','总卡数','销卡数']
        },
        xAxis: [
          {
            type: 'category',
            data: timeList,
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            name: '激活数',
            type: 'bar',
            data: activeList
          },
          {
            name: '停机数',
            type: 'bar',
            data: stopList
          },
          {
            name: '总卡数',
            type: 'bar',
            data: totalCardList
          },
          {
            name: '销卡数',
            type: 'bar',
            data: delCardList
          },
          {
            name: '激活数走势',
            type: 'line',
            label: {
                show: false,
            },
            tooltip: {
                show: false,
            },
            itemStyle: {
                color: '#4870DB',
            },
            lineStyle:{
                width:1
            },
            data: activeList
          }
        ]
      })
    }
  }
}
</script>
